import { graphql } from '@/gql';

export const SubmitPerformanceWeightResultMutation = graphql(`
    mutation SubmitPerformanceWeightResult($input: SubmitWeightResultInput!) {
        submitWeightResult(input: $input) {
            ... on SubmitWeightResultSuccessfulResponse {
                result {
                    ...WeightPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    message
                    field
                }
            }
        }
    }
`);

const _WeightPerformanceResult = graphql(`
    fragment WeightPerformanceResult on PerformanceResult {
        id
        companyId
        company {
            id
            name
        }
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        isTiedToAssessmentRun
        assessmentRunId
        assessmentRun {
            name
        }
        result {
            __typename
            ... on WeightResult {
                ...WeightPerformanceResultData
            }
        }
        createdAt
        completedAt
        updatedAt
        updatedBy
        isDeleted
    }
`);

const _WeightPerformanceResultData = graphql(`
    fragment WeightPerformanceResultData on WeightResult {
        weightKg
    }
`);
